
import { Vue, Component, Ref, Emit } from 'vue-property-decorator';
import previewModal from '@/components/richText/previewModal.vue';
import quilleditor from '@/components/richText/quilleditor.vue';
import { ICarSPUField } from '@/common/interface/carSpu';
import { EVehicleOperations } from '@/common/enum/carSpu';
import VehicleImagesField from './fields/VehicleImagesField.vue';
import CTypeField from './fields/CTypeField.vue';
import TagsField from './fields/TagsField.vue';
// import { DebounceTime } from '@/common/decorator';
import { FormModel } from 'ant-design-vue';

@Component({
  components: {
    previewModal,
    quilleditor,
  },
})
export default class VehicleModal extends Vue {
  visible = false;
  title = '标题';
  content = '';

  tagslist = [];

  formItems: any = [];

  shouldResetFields: any = false;
  form: { [key: string]: any } = {};
  rules: { [key: string]: any } = {};
  @Ref('previewModal') previewModal!: previewModal;

  @Ref()
  readonly ruleForm!: FormModel;

  // @DebounceTime(300)
  // @Watch('form', { deep: true })
  // watchForm() {
  //   if (!this.form) {
  //     return;
  //   }
  //   this.update();
  // }

  onClose() {
    this.visible = false;
  }
  init() {
    this.visible = true;
  }

  @Emit('submit')
  submit() {
    return { ...this.form };
  }

  onRuleFormSubmit() {
    this.ruleForm.validate((valid) => {
      if (valid) {
        this.submit();
      }
    });
  }

  // @Emit('update')
  // update() {
  //   // return { ...this.form };
  // }

  upload(val: any) {
    // console.log(val);
    this.content = val;
  }

  upTag(val: any, type: boolean) {
    console.log(val, type, '==================');
    // if (type) {
    //   console.log('清空', 'fosdasdasdasdasdrm');

    //   this.form.tags = [];
    //   console.log(this.form, 'dddddddd', 'fosdasdasdasdasdrm');
    // } else {
    //   this.$emit('update', this.form);
    // }
    this.form.tagslist = val;
    this.tagslist = val;
    this.$emit('update', this.form, type);

    console.log(this.form, 'fosdasdasdasdasdrm');
  }

  uploadFile(val: any, label: string) {
    this.form[label] = val;
    console.log(this.form, 'form');
    // this.update();
  }

  preview() {
    this.previewModal.init(this.form);
  }

  setup(
    fields: ICarSPUField[],
    spuForm: { [key: string]: any },
    shouldResetFields?: boolean,
  ) {
    this.shouldResetFields = shouldResetFields;
    this.formItems = fields;
    this.form = spuForm;
    this.setRulesAndFormItems(fields);

    if (shouldResetFields) {
      this.ruleForm.resetFields();
    }
  }
  setRulesAndFormItems(fields: ICarSPUField[]) {
    this.formItems = [...fields];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const rules: any = {};
    for (const field of fields) {
      rules[field.label] =
        field.rule && field.rule.length ? field.rule : undefined;
    }

    const ruleKeys = Object.keys(rules);
    for (const key of ruleKeys) {
      if (rules[key] === undefined) {
        delete rules[key];
      }
    }
    this.rules = rules;
    this.open();
  }
  open() {
    this.visible = true;
  }

  getComponent(label: string) {
    switch (label) {
      case EVehicleOperations.DESCRIPTION:
        return quilleditor;
      case EVehicleOperations.IMAGES:
        return VehicleImagesField;
      case EVehicleOperations.CID:
        return CTypeField;
      case EVehicleOperations.TAGS:
        return TagsField;
      default:
        return 'a-input';
    }
  }
  // submit() {
  //   console.log(this.form);
  // }
}
